export const AuditLogDocumentTitle = 'Audit Log';
